import { unref } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';
import { useAccount } from 'dashboard/composables/useAccount';
import { useConfig } from 'dashboard/composables/useConfig';
import {
  getUserPermissions,
  hasPermissions,
} from 'dashboard/helper/permissionsHelper';
import { INSTALLATION_TYPES } from 'dashboard/constants/installationTypes';

export function usePolicy() {
  const user = useMapGetter('getCurrentUser');
  const isOnChatwootCloud = useMapGetter('globalConfig/isOnChatwootCloud');
  const { isEnterprise } = useConfig();
  const { accountId } = useAccount();

  const checkPermissions = requiredPermissions => {
    if (!requiredPermissions || !requiredPermissions.length) return true;
    const userPermissions = getUserPermissions(user.value, accountId.value);
    return hasPermissions(requiredPermissions, userPermissions);
  };

  const checkInstallationType = config => {
    if (Array.isArray(config) && config.length > 0) {
      const installationCheck = {
        [INSTALLATION_TYPES.ENTERPRISE]: isEnterprise,
        [INSTALLATION_TYPES.CLOUD]: isOnChatwootCloud.value,
        [INSTALLATION_TYPES.COMMUNITY]: true,
      };
      return config.some(type => installationCheck[type]);
    }
    return true;
  };

  const shouldShow = (featureFlag, permissions, installationTypes) => {
    const perms = unref(permissions);
    const installation = unref(installationTypes);
    if (!checkPermissions(perms)) return false;
    if (!checkInstallationType(installation)) return false;
    return true;
  };

  return {
    checkPermissions,
    shouldShow,
  };
}
